import Icon from "components/Elements/Icon/Icon";
import React from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
const QuestionsList = ({
  category,
  questionsList,
  isSkeleton = null,
  isQuestion = null,
}) => {
  return (
    <div className="support-questions-list-page">
      <div className="support-questions">
        <div className="support-questions-title-container">
          {!isSkeleton && category.ImageUrl ? (
            <Icon
              className="support-plus-icon support-question-icon"
              name={category && category.ImageUrl.split(".")[0]}
              ext={category && category.ImageUrl.split(".")[1]}
            />
          ) : (
            <SkeletonTheme color="#e6e6e6" highlightColor="#f2f2f2">
              <Skeleton circle={true} height={50} width={50} />
            </SkeletonTheme>
          )}

          {!isSkeleton ? (
            <div>
              <h1 className="support-questions-title">
                {category.CategoryTitle === "JUMBOembed"
                  ? "JUMBOforms"
                  : category.CategoryTitle}
              </h1>
              <div className="category-descripition">
                {category.BrowserMetaDescription &&
                  category.BrowserMetaDescription.toLowerCase()}
              </div>
            </div>
          ) : (
            <div>
              <h1 className="support-questions-title">
                <Skeleton count={1} width={200} />
              </h1>
              {!isQuestion && (
                <div className="category-descripition">
                  <Skeleton count={1} width={250} />
                </div>
              )}
            </div>
          )}
        </div>

        {!isSkeleton
          ? questionsList.map((questions, i) => {
              // prevent when url question is not exist
              const newLink = window.location.pathname.includes("/a/")
                ? `${questions.SystemName}`
                : `a/${questions.SystemName}`;

              return (
                <div
                  className="support-questions-section-container"
                  key={questions.SupportCategoryQuestionId}
                >
                  <a href={newLink} className="support-questions-link" key={i}>
                    <div className="questions-text-container">
                      {questions.Title}
                    </div>
                  </a>
                </div>
              );
            })
          : renderSkeletonQuestionList()}
      </div>
    </div>
  );
};

const renderSkeletonQuestionList = () => {
  //render renderSkeletonQuestion 5 times
  return [1, 2, 3, 4, 5].map((i) => renderSkeletonQuestion(i));
};

const renderSkeletonQuestion = (i) => {
  return (
    <div key={i} className="support-questions-section-container">
      <a href={``} className="support-questions-link">
        <div className="questions-text-container">
          <SkeletonTheme>
            {" "}
            <Skeleton count={1} />
          </SkeletonTheme>
        </div>
      </a>
    </div>
  );
};
export default QuestionsList;
